import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { HtmlHighlightPart, extractHtmlHighlightParts } from '@ftr/foundation'

export type SearchHighlightType = 'Normal' | 'Subtle'

export interface SearchTextWithHighlightingInputs {
  highlightType: SearchHighlightType
  searchTextHtml: string
}

@Component({
  standalone: true,
  selector: 'ftr-search-text-with-highlighting',
  templateUrl: './search-text-with-highlighting.component.html',
  styleUrls: ['./search-text-with-highlighting.component.css'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchTextWithHighlightingComponent implements SearchTextWithHighlightingInputs {
  protected searchParts: HtmlHighlightPart[] = []
  @Input() set searchTextHtml(searchText: string) {
    this.searchParts = extractHtmlHighlightParts(searchText)
  }

  @Input() highlightType: SearchHighlightType = 'Normal'
}
